import { Link } from 'react-router-dom';

export function NotFoundPage() {
  return (
    <section className="mx-auto flex min-h-[70vh] max-w-md flex-col items-center justify-center px-6 text-center">
      <h1 className="text-2xl font-semibold text-gray-900">Page not found</h1>
      <p className="mt-2 text-gray-600">The page you&rsquo;re looking for doesn&rsquo;t exist.</p>
      <Link to="/" className="mt-6 text-brand-700 underline underline-offset-2">
        Back home
      </Link>
    </section>
  );
}
